export const hasSpecialChar = (value: string) => {
  return /[@#\-_$%^&+=§!?]/g.test(value);
};
